import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "EG_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#EG_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "EG_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#EG_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#BF2714"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.26 10.22l1 .046-.251 5.47-1-.046.252-5.47zM13.303 10.56l.999.057-.25 4.435-1-.056.252-4.436z",
      fill: "#C09302"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.348 10.893l.997.081-.25 3.056-.997-.081.25-3.056zM19.74 10.22l-1 .046.251 5.47 1-.046-.252-5.47zM18.697 10.56l-.999.057.25 4.435 1-.056-.252-4.436z",
      fill: "#C09302"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.652 10.893l-.997.081.25 3.056.997-.081-.25-3.056zM15.973 15.327l-.975-.224.413-1.8.974.223-.412 1.8z",
      fill: "#C09302"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.719 15.327l.974-.224-.412-1.8-.975.223.413 1.8z",
      fill: "#C09302"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.47 15.31h-1v-1.768h1v1.768zM14.635 10.914l1 .025-.06 2.38-.999-.024.059-2.38zM16.373 10.914l1 .025-.059 2.38-1-.024.059-2.38z",
      fill: "#C09302"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.338 15.924l.26-.966c1.06.285 1.875.426 2.43.426.556 0 1.371-.14 2.432-.426l.26.966c-1.139.306-2.031.46-2.691.46-.66 0-1.553-.154-2.691-.46zM12.283 10.223c-.067-.66.32-1.108.975-1.05.216.018.458.082.78.191l.185.065c.444.158.564.198.589.203-.098-.022.19-.545.257-.633.008.056-.025.048-.105.032l-.902-.18.642-.659a1.17 1.17 0 01.864-.344c.036 0 .069-.002.177-.009.08-.005.08-.005.17-.008.624-.02 1.072.156 1.072.798 0 .23.029.598.077.878.016.094.047.183-.045.221.004-.033.222-.12.562-.261l.041-.017c.988-.413 1.103-.45 1.421-.257.212.129.414.36.64.706l-.836.548c-.146-.223-.262-.358-.318-.396.126.087-.298.228-.522.321l-.04.017c-.769.322-.87.36-1.09.36-.598 0-.813-.613-.872-1.49-.184.607-.735 1.374-1.189 1.374-.198 0-.103.032-.928-.262l-.171-.06a2.699 2.699 0 00-.544-.142.463.463 0 01.04-.04l-.93.094z",
      fill: "#C09302"
    }
  )))
);
export {
  t as default
};
